import * as React from 'react';
import { BookingContext } from '../components/BookingContextProvider';

export default function useBookingContext() {
    return React.useContext(BookingContext);
}

export function useRequiredBookingContext() {
    const context = React.useContext(BookingContext);

    if (!context.citySlug || !context.locationSlug || !context.location) {
        throw new Error(
            // eslint-disable-next-line max-len
            'citySlug,  locationSlug, or location are undefined – are you sure you want to use this hook?',
        );
    }

    return context as Required<typeof context>;
}
